<template>
  <div class="manage-profile">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3 class="text-bold">Profile</h3>
        </div>
      </div>
      <div class="row py-4">

        <div class="col-12 mb-2">
          <!-- add user modal -->
          <b-modal hide-header size="lg" id="addUser">
            <div class="p-4">
              <h3 class="mb-4">Add user</h3>
              <h6 class="mb-4">Enter the email address of the user you want to add and select the role they should have</h6>
              <b-alert show variant="danger" v-if="addUserErrors.length">
                <p v-for="error in addUserErrors" :key="error" class="m-0">
                  {{ error }}
                </p>
              </b-alert>
              <div class="row mb-4">
                <div class="col-12 col-md-6 mb-3 mb-md-0">
                  <label class="h6" for="">Email Address</label>
                  <b-form-input v-model="userRoleEmail" placeholder="Enter user's email address"></b-form-input>
                </div>
                <div class="col-12 col-md-6">
                  <label class="h6" for="">User Role</label>
                  <b-form-select v-model="selectedUserRole" :options="userRoleOptions"></b-form-select>
                </div>
              </div>
              <div class="bg-dark-cyan p-4">
                <div class="row mb-3">
                  <div class="col-12 mb-3">
                    <h6 class="mb-0">User Roles</h6>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-12 col-md-6 mb-3 mb-md-0">
                    <h6 class="mb-0">Administrator</h6>
                    <p class="mb-0">Administrator user permissions</p>
                  </div>
                  <div class="col-12 col-md-6">
                    <h6 class="mb-0">Viewers</h6>
                    <p class="mb-0">Viewers user permissions</p>
                  </div>
                </div>
                <!-- <div class="row">
                  <div class="col-12 col-md-6 mb-3 mb-md-0">
                    <h6 class="mb-0">Agents</h6>
                    <p class="mb-0">Agents user permissions</p>
                  </div>
                  <div class="col-12 col-md-6">
                    <h6 class="mb-0">Manager</h6>
                    <p class="mb-0">Manager user permissions</p>
                  </div>                  
                </div> -->
              </div>
            </div>
            <template #modal-footer="{cancel}">
              <div class="w-100 d-flex">
                <b-button variant="success" class="rounded-pill mr-2 w-100" @click="addUser">Add User</b-button>
                <b-button variant="outline-primary" class="rounded-pill w-100" @click="cancel()">Cancel</b-button>
                <!-- nested success modal -->
                <b-modal id="inviteSend" hide-header hide-footer>
                  <div class="text-center">
                    <i class="fa fa-check p-4 mt-5 rounded-circle bg-success text-white"></i>
                    <h3 class="mt-3">Invite sent to user</h3>
                    <div class="d-flex justify-content-center py-5">
                      <b-button variant="success" class="rounded-pill px-5 mr-1" @click="$bvModal.hide('inviteSend')">Add another user</b-button>
                      <b-button variant="outline-primary" class="rounded-pill px-5 ml-1" @click="closeAll">Back To Profile</b-button>
                    </div>
                  </div>
                </b-modal>
                <!-- /nested success modal -->
              </div>
            </template>
          </b-modal>
          
          <!-- edit user modal -->
          <b-modal hide-header size="lg" id="editUser">
            <div class="p-4">
              <h3 class="mb-4">Edit User</h3>
              <h6 class="mb-4">Enter the email address of the user you want to add and select the role they should have</h6>
              <b-alert show variant="danger" v-if="addUserErrors.length">
                <p v-for="error in addUserErrors" :key="error" class="m-0">
                  {{ error }}
                </p>
              </b-alert>
              <div class="row mb-4">
                <div class="col-12 col-md-6 mb-3 mb-md-0">
                  <label class="h6 mt-5" for="">Email Address</label>
                  <input type="text" v-model="editingUser" class="form-control rounded-none" disabled>
                  <label class="h6 mt-4" for="">User Role</label>
                  <b-form-select v-model="editingUserRole" :options="userRoleOptions"></b-form-select>
                </div>
                <div class="col-12 col-md-6">
                  <div class="row">
                    <div class="col-12 mb-3">
                      <h6 class="mb-0">User Roles</h6>
                    </div>
                  </div>
                  <div class="bg-dark-cyan p-4">
                    <div class="row">
                      <div class="col-12 mb-3">
                        <h6 class="mb-0">Administrator</h6>
                        <p class="mb-0">Administrator user permissions</p>
                      </div>
                      <!-- <div class="col-12 mb-3">
                        <h6 class="mb-0">Manager</h6>
                        <p class="mb-0">Manager user permissions</p>
                      </div>
                      <div class="col-12 mb-3">
                        <h6 class="mb-0">Agents</h6>
                        <p class="mb-0">Agents user permissions</p>
                      </div> -->
                      <div class="col-12 mb-3">
                        <h6 class="mb-0">Viewers</h6>
                        <p class="mb-0">Viewers user permissions</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
            <template #modal-footer="{ok, cancel}">
              <div class="w-100 d-flex">
                <b-button variant="success" class="rounded-pill px-5 mr-2" @click="doEditUser">
                  <b-spinner v-if="loading" variant="light" label="Spinning"></b-spinner>
                  <span v-else>
                    Save Changes
                  </span>  
                </b-button>
                <b-button variant="outline-primary" class="rounded-pill px-5" @click="cancel()">Cancel</b-button>
              </div>
            </template>
          </b-modal>
        </div>
        
        <div class="col-12 px-0 border-none border-md-right profile-nav">
          <!-- active-nav-item-class="border-bottom border-5 border-active" -->
          <b-tabs
            active-nav-item-class="nav-active"
            class="m-0 d-flex flex-column flex-md-row"
            nav-wrapper-class="px-0 col-12 col-md-3 b-tabs">

            <!-- <b-tab
              :title-item-class="['w-100']"
              :title-link-class="['font-weight-bold text-gray border-0 py-3 pr-5']"
              title="Account Information"
              active>
              <b-tabs active-nav-item-class="border-bottom border-active" content-class="shadow" class="mx-2">
                <b-tab :title-link-class="['border-0 py-3 px-5']" title="Account Profile" active>
                  <div class="bg-gray p-4 rounded d-flex flex-column">
                    <p class="mb-4 text-bold">Enter details of your account</p>

                    <div class="form-group">
                      <p class="mb-0 text-bold">Company Name</p>
                      <input type="text" class="form-control border-radius-0" placeholder="" v-model="userProfile.account.name">
                    </div>
                    
                    <div class="form-group">
                      <p class="mb-0 text-bold">Company Contact Number</p>
                      <input type="text" class="form-control" placeholder="" v-model="userProfile.account.phone_number">
                    </div>
                    
                    <div class="form-group">
                      <p class="mb-0 text-bold">Company Email Address</p>
                      <input type="text" class="form-control" placeholder="" v-model="userProfile.account.email">
                    </div>
                    
                    <div class="form-group">
                      <p class="mb-0 text-bold">Mail Address</p>
                      <input type="text" class="form-control" placeholder="" v-model="userProfile.account.mail_address">
                    </div>
                    
                    <div class="form-group">
                      <p class="mb-0 text-bold">Ghana Post Code</p>
                      <input type="text" class="form-control" placeholder="" v-model="userProfile.account.ghana_post_code">
                    </div>
                    
                    <div class="form-group">
                      <p class="mb-0 text-bold">Text ID Number</p>
                      <input type="text" class="form-control" placeholder="" v-model="userProfile.account.tax_id_number">
                    </div>

                    <div class="form-group">
                      <button class="btn btn-success px-5" @click="save">Save</button>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </b-tab> -->

            <b-tab
              :title-item-class="['']"
              :title-link-class="['font-weight-bold text-gray border-left-0 border-bottom-0 border-top-0 py-3 pr-5']"
              title="User Profile">
                <div class="rounded bg-gray py-4 px-4 mx-0 mx-md-2">
                  <div class="row font-weight-bold">
                    
                    <div class="col-12">
                      <p>Update basic information</p>
                    </div>

                    <div class="col-12 col-lg-7 form-group mb-4">
                      <p class="mb-1">First Name</p>
                      <input type="text" class="form-control" placeholder="" v-model="userProfile.first_name">
                    </div>

                    <div class="col-12 col-lg-7 form-group mb-4">
                      <p class="mb-1">Last Name</p>
                      <input type="text" class="form-control" placeholder="" v-model="userProfile.last_name">
                    </div>

                    <div class="col-12 col-lg-7 form-group mb-5">
                      <p class="mb-1">Phone Number</p>
                      <input type="text" class="form-control" placeholder="" v-model="userProfile.phone_number">
                    </div>

                    <div class="col-12">
                      <button class="btn btn-success px-5" @click="save">Save</button>
                    </div>

                  </div>
                </div>
            </b-tab>

            <!-- <b-tab
              :title-item-class="['w-100']"
              :title-link-class="['font-weight-bold text-gray border-0 py-3 pr-5']"
              title="Settlement">
                <b-tabs active-nav-item-class="border-bottom border-active" class="mx-2">

                  <b-tab title="Mobile Money" :title-link-class="['border-0']">
                    <div class="rounded bg-gray py-4 px-5">
                      <div class="row font-weight-bold">

                        <div class="col-12 mb-4">
                          <p>Enter details for your mobile money account</p>
                        </div>

                        <div class="col-12 col-lg-7 form-group">
                          <b-form-select 
                            v-model="userProfile.account.mobile_money_account && userProfile.account.mobile_money_account.network.id" 
                            :options="banksAndMoneyNetworks.mobile_money_networks"
                            value-field="id"
                            text-field="name"
                          ></b-form-select>
                        </div>

                        <div class="col-12 col-lg-7 form-group">
                          <p class="mb-1">Mobile Money Nummber</p>
                          <input 
                            type="text" 
                            class="form-control" 
                            placeholder="Enter Your Mobile Money Number" 
                            v-model="userProfile.account.mobile_money_account && userProfile.account.mobile_money_account.number"
                          >
                        </div>

                        <div class="col-12 col-lg-7 form-group">
                          <div class="row d-flex align-items-center">
                            <div class="col-1 pr-0">
                              <input type="checkbox" name="" id="" class="form-control">
                            </div>
                            <div class="col-11">
                              <p class="mb-0">Use as default settlement account</p>
                            </div>
                          </div>
                        </div>

                        <div class="col-12">
                          <button class="btn btn-success px-5" @click="save">Save</button>
                        </div>

                      </div>
                    </div>
                  </b-tab>

                  <b-tab title="Bank Account" :title-link-class="['border-0']">
                    <div class="rounded bg-gray px-5 py-4">
                      <div class="row font-weight-bold mb-5">
                        <div class="col-12">
                          <p>Enter details for your bank account information</p>
                        </div>

                        <div class="col-12">
                          <div class="row d-flex">
                            <div class="col-12 col-lg-6 d-flex align-items-end">
                              <b-form-select 
                                v-model="userProfile.account.bank_account && userProfile.account.bank_account.bank.id" 
                                :options="banksAndMoneyNetworks.banks"
                                value-field="id"
                                text-field="name"
                              ></b-form-select>
                            </div>
                            <div class="col-12 col-lg-6">
                              <p class="mb-1">Bank Branch</p>
                              <input type="text" class="form-control" placeholder="Enter Your Branch Location" 
                                v-model="userProfile.account.bank_account && userProfile.account.bank_account.bank_branch"
                              >
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row mb-5">
                        <div class="col-6">
                          <b-form-select 
                              v-model="userProfile.account.bank_account && userProfile.account.bank_account.bank.currency" 
                              :options="banksAndMoneyNetworks.currencies"
                              value-field="iso2"
                              text-field="iso2"
                            ></b-form-select>
                        </div>
                      </div>

                      <div class="row font-weight-bold mb-5">
                        <div class="col-6">
                          <p class="mb-1">Account Number</p>
                          <input type="text" class="form-control" placeholder="Enter Your Account Number" 
                            v-model="userProfile.account.bank_account && userProfile.account.bank_account.account_number"
                          >
                        </div>
                      </div>

                      <div class="row font-weight-bold mb-5">
                        <div class="col-6">
                          <p class="mb-1">Account Name</p>
                          <input type="text" class="form-control" placeholder="Enter Your Account Name" 
                            v-model="userProfile.account.bank_account && userProfile.account.bank_account.account_name"
                          >
                        </div>
                      </div>

                      <div class="row d-flex align-items-center mb-3">
                        <div class="col-1 px-4">
                          <input type="checkbox" name="" id="" class="form-control">
                        </div>
                        <div class="col-11 pl-0">
                          <p class="mb-0">Use as default settlement account</p>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12">
                          <button class="btn btn-success px-5" @click="save">Save</button>
                        </div>
                      </div>
                    </div>
                  </b-tab>
                </b-tabs>
            </b-tab> -->

            <b-tab
              :title-item-class="['w-100']"
              :title-link-class="['font-weight-bold text-gray border-0 py-3 pr-5']"
              title="Roles And Permissions"
              v-if="userContext.user.role == 'admin'">
              <div class="bg-gray p-4 rounded mx-2">
                <div class="d-flex justify-content-between align-items-center">
                  <p class="font-weight-bold mb-0">Roles And Permissions</p>
                  <button v-b-modal.addUser class="btn btn-primary px-4 rounded-pill">Add User</button>
                </div>
                <div class="mt-5 overflow-auto">
                  <b-table
                    :items="accountUsers.results"
                    :fields="masterTableProps.fields"
                    :table-variant="tableVariant"
                    :thead-class="['th-gray']"
                    :tbody-class="['border-0']"
                    th>
                      <template #empty>
                        <empty-table></empty-table>
                      </template>
                      <template #head(email)>
                        <p class="mb-0 font-weight-bold text-dark">Email Address</p>
                      </template>
                      <template #head(role)>
                        <p class="mb-0 font-weight-bold text-dark">Role</p>
                      </template>
                      <template #head(created_at)>
                        <p class="mb-0 font-weight-bold text-dark">Date Added</p>
                      </template>
                      <template #cell(created_at)="data">
                        {{ new Date(data.item.created_at) | dateFormat('DD/MM/YYYY h:mm A') }}
                      </template>
                      <template #cell(edit)="data">
                        <button class="btn btn-primary rounded-pills py-0 px-4" @click="editUser(data.item)">Edit</button>
                      </template>
                      <template #cell(delete)="data">
                        <button class="btn btn-danger rounded-pills py-0 px-4" @click="deleteUser(data.item)">Delete</button>
                      </template>
                  </b-table>
                </div>
              </div>
            </b-tab>

            <b-tab
              :title-item-class="['']"
              :title-link-class="['font-weight-bold text-gray text-center text-md-left border-left-0 border-bottom-0 border-top-0 py-3 pr-5']"
              title="Password Setting">
                <div class="rounded bg-gray px-5 py-4 mx-0 mx-md-2">
                  <div class="row font-weight-bold">
                    <div class="col-12">
                      <p>Change your password settings</p>
                    </div>
                    <div class="col-12 col-lg-7">
                      <div class="mt-4">
                          <b-alert variant="success" :show="successMessage">Password Changed Successfully</b-alert>
                          <b-alert variant="danger" :show="errorChangePassMessage">Error, password not changed.</b-alert>
                      </div>
                      <b-form  @submit.prevent="changePassword" :validated="validate_form">
                        <label for="feedback-user">Current Password</label>
                        <b-form-input type="password" v-model="current_password" placeholder="enter your current password"></b-form-input>
                        <label for="feedback-user" class="mt-3">New Password</label>
                        <b-form-input type="password" v-model="new_password" placeholder="enter your new password"></b-form-input>
                        <label for="feedback-user" class="mt-3">Confirm New Password</label>
                        <b-form-input type="password" v-model="confirm_new_password" :state="validation" placeholder="confirm your new password"></b-form-input>
                        <b-form-invalid-feedback :state="validation">
                          Your confirm Password must be the same with new password.
                        </b-form-invalid-feedback>
                        <b-form-valid-feedback :state="validation">
                          Your new password and confirm password has been match.
                        </b-form-valid-feedback>
                        <div class="mt-4">
                          <div class="pa-2">
                            <b-button class="btn btn-success px-5" type="submit" @submit.prevent="changePassword">
                              <b-spinner v-if="loadingChangePassword" variant="light" label="Spinning"></b-spinner>
                              <span v-else>
                                Reset Password
                              </span>
                            </b-button>
                          </div>
                        </div>
                        
                      </b-form>
                    </div>
                  </div>
                </div>
            </b-tab>

            <b-tab
              :title-item-class="['']"
              :title-link-class="['font-weight-bold text-gray text-center text-md-left border-left-0 border-bottom-0 border-top-0 py-3 pr-5']"
              title="2 Factor Authentication">
                <div class="rounded bg-gray px-3 px-md-5 py-4 mx-0 mx-md-2">
                  <b-form @submit.prevent="onSubmitTwoFactor">

                    <b-form-checkbox v-model="twoFactorChecked" name="check-button" switch>
                      <p class="mb-0 h6">Enable 2 Factor Authentication</p>
                    </b-form-checkbox>

                    <!-- <div class="row my-5">
                      <div class="col-12 col-md-7">
                        <p class="font-weight-bold">Preferred Method</p>
                        <p class="mb-0 h6">Select the method you would like to receive your verification code</p>
                      </div>
                    </div>
                    
                    <div class="row">
                      <div class="col-12 d-flex align-items-center">
                        <input class="mr-3" type="radio" name="method" id="">
                        <div class="w-100 row">
                          <div class="col-12 col-md-6">
                            <p class="mb-0 h6 text-gray">Phone Number</p>
                            <input type="text" class="form-control rounded-none" placeholder="Enter Your Phone Number">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-5">
                      <div class="col-12 d-flex align-items-center">
                        <input class="mr-3" type="radio" name="method" id="">
                        <div class="w-100 row">
                          <div class="col-12 col-md-6">
                            <p class="mb-0 h6 text-gray">Email</p>
                            <input type="text" class="form-control rounded-none" placeholder="Enter Your Email">
                          </div>
                        </div>
                      </div>
                    </div> -->
                    <div class="row mt-5">
                      <div class="col-8 offset-2 col-md-3 offset-md-0">
                        <button class="btn btn-success w-100">Save</button>
                      </div>
                    </div>
                  </b-form>
                </div>
            </b-tab>
          </b-tabs>
        </div>

      </div>
      <div class="row">
        <div class="col-12 px-0">
          <b-button pill class="px-4" variant="primary" @click="logout"><i class="fas fa-sign-out-alt"></i> Log Out</b-button>
          <!-- <a
            :title-item-class="['btn btn-primary rounded-pills']"
            :title-link-class="['text-white border-left-0 border-bottom-0 border-top-0']"
            title="Log Out">
          </a> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TransactionAPI from '../api/transactions_api';
import store from '../store';
import parsePhoneNumber from 'libphonenumber-js';
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import EmptyTable from '../utils/empty-table.vue';

export default {
  components: {
    VueTelInput,
    parsePhoneNumber,
    EmptyTable
  },
  data() {
    return {
      errorChangePassMessage: false,
      successMessage: false,
      loadingChangePassword: false,
      current_password: null,
      confirm_new_password: null,
      new_password: null,
      step: 1,
      payer: true,
      vendor: false,
      citiesCount: 0,
      formDependency: {},
      supportedMobileNetworks: [],
      supportedBanks: [],
      industryMemberships: [],
      supportedCurrencies: [],
      active: true,
      authenticated: '',
      proceed: true,
      headerTag: {
        'animated fadeInUp': false,
        hidden: true,
      },
      step1: {
        completed: false,
        active: true,
      },
      step2: {
        completed: false,
        active: false,
      },
      step3: {
        completed: false,
        active: false,
      },
      step4: {
        completed: false,
        active: false,
      },
      cities: [],
      registerStatus: 0,
      loadingStatus: 0,
      tempToken: {},
      errorMessage: 'Account Creation Failed',
      phoneNumberConfig: {
        numericOnly: true,
        blocks: [3, 3, 3, 3, 3],
      },
      baseUrl: '',
      tableVariant: 'test',
      addUserErrors: [],
      userRoleEmail: '',
      selectedUserRole: 'viewer',
      userRoleOptions: ['viewer', 'admin'],
      loading: false,
      twoFactorChecked: false,
      masterTableProps: {
        fields: [
          {
            key: 'email',
            sortable: false,
            label: 'Email Address'
          },
          {
            key: 'role',
            sortable: false,
            label: 'Role'
          },
          {
            key: 'created_at',
            sortable: false,
            label: 'Date Added'
          },
          {
            key: 'edit',
            sortable: false,
            label: ''
          },
          {
            key: 'delete',
            sortable: false,
            label: ''
          },
        ],
        resultsPerPage: 10,
        currentPage: 1,
        sortBy: 'created_at',
        sortDirection: 'asc',
        totalRows: 1,
        sortDesc: true
      },
      editingUserId: null,
      editingUser: '',
      editingUserRole: '',
      deletingUserId: null,
      userContext: null
    };
  },
  computed: {
    change_password: {
      get: function () {
        return store.state.change_password;
      },
      set: function (newValue) {
        store.state.change_password = newValue;
      }
    },
    validate_form () {
      if (this.new_password && this.confirm_new_password && this.current_password && this.new_password === this.confirm_new_password) {
        return true;
      }
    },
    validation () {
      if (this.new_password && this.confirm_new_password) {
        return this.new_password === this.confirm_new_password;
      }
    },
    userProfile: {
      get: function () {
        return store.state.userProfile;
      },
      set: function (newValue) {
        store.state.userProfile = newValue;
      }
    },
    banksAndMoneyNetworks: {
      get: function () {
        return store.state.banksAndMoneyNetworks;
      },
      set: function (newValue) {
        store.state.banksAndMoneyNetworks = newValue;
      }
    },
    accountUsers: {
      get: function () {
        return store.state.accountUsers;
      },
      set: function (newValue) {
        store.state.accountUsers = newValue;
      }
    },
    editAccountUser: {
      get: function () {
        return store.state.editAccountUser;
      },
      set: function (newValue) {
        store.state.editAccountUser = newValue;
      }
    },
  },
  mounted() {
    const userContext = JSON.parse(localStorage.getItem('loginToken'));

    this.userContext = userContext;
    this.baseUrl = `${process.env.VUE_APP_BASE_URL}`;

    if (userContext) {
      this.twoFactorChecked = userContext.user.two_factor_auth_enabled;
    }
  },
  beforeMount() {
    //this.tokenizer();
    this.init();
  },
  methods: {
    deleteUser(user) {
      this.deletingUserId = user.id;
      if (this.deletingUserId && this.accountUsers.count > 1) {
        var deleteConfirm = confirm('Are you sure you want to delete this user?');
      
        if (deleteConfirm) {
          TransactionAPI.methods.deleteAccountUser(this.deletingUserId)
          .then(verResponse => {
            if (store.state.deleteAccountUser.status == 400) {
              this.addUserErrors.push('Error deleting user');
            }

            if (store.state.deleteAccountUser.status >= 200 && store.state.deleteAccountUser.status < 300) {
              const message = 'Successfully deleted user!';
              this.$bvToast.toast(`${message}`, {
                title: 'Status Message',
                autoHideDelay: 5000,
                appendToast: false
              });

              TransactionAPI.methods.getAccountUsers();
            }
            
            this.loading = false;
          });
        }
      } else {
        console.log('need to have more than 1 user in order to delete');
      }
    },
    editUser(user) {
      this.editingUser = user.email;
      this.editingUserId = user.id;
      this.editingUserRole = user.role;
      this.$bvModal.show('editUser');
    },
    doEditUser() {
      this.loading = true;
      this.addUserErrors = [];
      const payload = {
        email: this.editingUser,
        role: this.editingUserRole
      };

      const message = 'User role successfully updated!';
      
      TransactionAPI.methods.editAccountUser(this.editingUserId, payload)
        .then(verResponse => {
          if (store.state.editAccountUser.status == 400) {
            this.addUserErrors.push('Error editing user');
          }

          if (store.state.editAccountUser.status == 200) {
            this.$bvModal.hide('editUser');
            this.$bvToast.toast(`${message}`, {
              title: 'Status Message',
              autoHideDelay: 5000,
              appendToast: false
            });

            TransactionAPI.methods.getAccountUsers();
          }
          
          this.loading = false;
        });
    },
    closeAll() {
      this.$bvModal.hide('inviteSend');
      this.$bvModal.hide('addUser');
    },
    logout() {
      localStorage.removeItem('loginToken');
      localStorage.removeItem('userLocation');
      this.authenticated = false;
      this.$router.push({name: 'Login'});
    },
    addUser() {
      this.addUserErrors = [];

      // should iterate through addUserErrors: [],
      if (!this.userRoleEmail.length) {
        this.addUserErrors.push('Email cannot be empty');
      }

      if (!this.selectedUserRole.length) {
        this.addUserErrors.push('User role cannot be empty');
      }
 
      if (this.addUserErrors.length == 0) {
        const payload = {
          email: this.userRoleEmail,
          role: this.selectedUserRole
        };
        this.loading = true;

        TransactionAPI.methods.createAccountUser(payload)
        .then(verResponse => {
          if (store.state.createAccountUser.status == 400) {
            this.addUserErrors.push('Error creating user');
            const data = store.state.createAccountUser.response.data;

            for (const property in data) {
              this.addUserErrors.push(data[property][0]);
            }
          }

          if (store.state.createAccountUser.status == 201) {
            this.$bvModal.show('inviteSend');
            TransactionAPI.methods.getAccountUsers();
          }
          
          this.loading = false;
        });
      }
    },
    reset () {
      this.new_password = null
      this.confirm_new_password = null
      this.current_password = null
    },
    changePassword () {
      if (this.validate_form) {
        this.successMessage = false;
        this.errorChangePassMessage = false;
        this.loadingChangePassword = true;

        const payload = {
          old_password: this.current_password,
          new_password: this.new_password
        };

        TransactionAPI.methods.doChangePassword(payload)
        .then(verResponse => {
          if (this.change_password.data.code == 200) {
            this.successMessage = true
          } else {
            throw this.change_password.data.detail
          }
          this.errorChangePassMessage = false
          this.reset();
        })
        .catch(error => {
          this.errorChangePassMessage = true
          this.reset();
          console.log('error', error);
        })
        .finally(() => {
          this.loadingChangePassword = false
        })
      }
    },
    countryCodeHandler(evt) {
      this.selectedCountry = evt;
    },
    init() {
      var self = this;

      this.$preloaders.open();

      TransactionAPI.methods.getProfile()
      .then(verResponse => {
          self.$preloaders.close();
          console.log('store.state.userProfile', store.state.userProfile);
      });

      // get money networks, and banks https://jetpay-api.herokuapp.com/api/v1/accounts/sign_up_initialize/
      TransactionAPI.methods.signUpInitialize();
      TransactionAPI.methods.getAccountUsers();
    },
    handleExpiredToken() {
      this.$router.push({name: 'Login'});
    },
    makeToast(message) {
      this.$bvToast.toast(`${message}`, {
        title: 'Status Message',
        autoHideDelay: 5000,
        appendToast: false
      })
    },
    save() {
      var self = this,
        copy = JSON.stringify(this.userProfile),
        createAccountPayload = {
          ...JSON.parse(copy),
        };
      // console.log('this.userProfile', this.userProfile);
      // createAccountPayload.account.mobile_money_account.network = this.userProfile.account.mobile_money_account.network ? this.userProfile.account.mobile_money_account.network.id : null;
      // createAccountPayload.account.bank_account.bank = this.userProfile.account.bank_account.bank ? this.userProfile.account.bank_account.bank.id : null;

      this.$preloaders.open();

      TransactionAPI.methods.updateProfile(createAccountPayload)
      .then(verResponse => {
          self.$preloaders.close();
          console.log('saved profile  ');
          self.makeToast('Profile Updated Successfully!');
      })
      .catch(error => {
          console.log('error', error);
          self.makeToast('There was an issue with updating your profile, try again later.');
          //self.handleExpiredToken();
      });
    },
    tokenizer() {
      const userContext = localStorage.getItem('loginToken');
      if (userContext) {
        window.location.href = './dashboard';
      }
    },
    onSubmitTwoFactor(evt) {
      const self = this;
      const payload = {
        enabled: this.twoFactorChecked
      };

      console.log('this.twoFactorChecked', this.twoFactorChecked);
      
      this.$preloaders.open();

      TransactionAPI.methods.doToggleTwoFactor(payload)
      .then(verResponse => {
          self.$preloaders.close();
          console.log('saved profile');
          self.makeToast('Profile Updated Successfully!');

          const userContext = JSON.parse(localStorage.getItem('loginToken'));
          userContext.user.two_factor_auth_enabled = self.twoFactorChecked;
          localStorage.setItem('loginToken', JSON.stringify(userContext));

          console.log('usercontxt value', userContext['2fa']);
      })
      .catch(error => {
          console.log('error', error);
          self.makeToast('There was an issue with updating your profile, try again later.');
          //self.handleExpiredToken();
      });

      console.log('onSubmitTwoFactor', this.twoFactorChecked);
    }
  },
};
</script>
<style>
  .text-gray {
    color: #b1b1b1 !important;
  }
  .bg-gray {
    background: #f1f1f1;
  }
  .bg-dark-cyan {
    background: #d9e4e9;
  }
  .rounded-pills {
    border-radius: 50px;
  }
  .profile-nav a:hover {
    text-decoration: none;
    color: #2194c2;
    border-right: 3px solid #2194c2;
  }
  .nav-active {
    color: #2194c2 !important;
    border-right: 3px solid #2194c2 !important;
    border-top-right-radius: 0 !important;
  }
  .manage-profile .nav-tabs .nav-item {
    width: 100%;
  }
  .profile-nav .nav-content {
    min-height: 100%;
  }
  .tabs {
    flex-direction: column;
  }
  .border-active {
    border-bottom: 3px solid #2194c2 !important;
  }
  .form-control {
    border-radius: 0;
  }
  .content table {
    box-shadow: none;
    background: none;
  }
  .table tr:hover {
    background-color: initial;
  }
  .manage-profile .nav-tabs .tab-content {
    width: 100%;
  }
  .tabs .tab-content {
    width: 100%;
  }
  .th-gray {
    background: #e4e4e4;
  }
  .b-tabs {
    border-right: 1px solid #f1f1f1;
  }
  @media (max-width: 767px) {
    .nav-tabs .nav-active {
      color: #2194c2 !important;
      border-bottom: 3px solid #2194c2 !important;
      border-right: none !important;
      border-top-right-radius: 0 !important;
    }
    .manage-profile .nav-tabs .nav-item {
      width: 50% !important;
    }
    .nav-tabs .b-tabs {
      border-right: none;
    }
    .dashboard-content {
      margin-bottom: 120px;
    }
  }
</style>